import { useSelector } from 'react-redux'
import { selectLabelById } from 'selectors/labels'

export default function TagLabel({ labelId }) {
  const { name = 'REMOVED' } =
    useSelector(state => selectLabelById(state, labelId)) || {}
  return <>{name}</>
}
